<div class="flex h-full w-full">
  <div class="bg-neutral-0 flex flex-col border-r border-neutral-200" style="width: 195px">
    <nav class="flex flex-col gap-0.5 p-4">
      <a
        [routerLink]="[CmsUrlParts.QuadraticFunctions]"
        routerLinkActive="active"
        class="sidebar-link text-secondary flex w-full items-center truncate px-2 py-1.5 text-sm font-medium"
        #quadraticRla="routerLinkActive"
      >
        <dojo-icon
          [icon]="'function'"
          [iconClass]="quadraticRla.isActive ? 'text-sky-500' : 'text-secondary'"
          [size]="12"
          class="mr-2"
        />
        <span class="truncate">Quadratic Functions</span>
      </a>
      <a
        [routerLink]="[CmsUrlParts.SuperLatex]"
        routerLinkActive="active"
        class="sidebar-link text-secondary flex w-full items-center truncate px-2 py-1.5 text-sm font-medium"
        #superLatexRla="routerLinkActive"
      >
        <dojo-icon
          [icon]="'square-root-variable'"
          [iconClass]="superLatexRla.isActive ? 'text-sky-500' : 'text-secondary'"
          [size]="12"
          class="mr-2"
        />
        <span class="truncate">Super LaTeX</span>
      </a>
      <a
        [routerLink]="[CmsUrlParts.Solver]"
        routerLinkActive="active"
        class="sidebar-link text-secondary flex w-full items-center truncate px-2 py-1.5 text-sm font-medium"
        #solverRla="routerLinkActive"
      >
        <dojo-icon
          [icon]="'list-check'"
          [iconClass]="solverRla.isActive ? 'text-sky-500' : 'text-secondary'"
          [size]="12"
          class="mr-2"
        />
        <span class="truncate">Solver</span>
      </a>
      <a
        [routerLink]="[CmsUrlParts.Graph]"
        routerLinkActive="active"
        class="sidebar-link text-secondary flex w-full items-center truncate px-2 py-1.5 text-sm font-medium"
        #graphRla="routerLinkActive"
      >
        <dojo-icon
          [icon]="'chart-line'"
          [iconClass]="graphRla.isActive ? 'text-sky-500' : 'text-secondary'"
          [size]="12"
          class="mr-2"
        />
        <span class="truncate">Graph</span>
      </a>
      <a
        [routerLink]="[CmsUrlParts.StudyNotesEditor]"
        routerLinkActive="active"
        class="sidebar-link text-secondary flex w-full items-center truncate px-2 py-1.5 text-sm font-medium"
        #studyNotesRla="routerLinkActive"
      >
        <dojo-icon
          [icon]="'file-lines'"
          [iconClass]="studyNotesRla.isActive ? 'text-sky-500' : 'text-secondary'"
          [size]="12"
          class="mr-2"
        />
        <span class="truncate">Study Notes</span>
      </a>
    </nav>
  </div>

  <div class="flex-1 overflow-y-auto bg-neutral-50">
    <router-outlet />
  </div>
</div>
